import { ApiClientError, requestJson, responseArray, responseRecord } from './http';

export { ApiClientError as ProjectsApiError };

export interface Project {
  project_id: string;
  org_id: string;
  slug: string;
  display_name: string;
  status: string;
  created_at: string;
  created_by: string;
  archived_at: string | null;
}

function projectFrom(value: unknown): Project {
  const record = responseRecord(value);
  for (const field of ['project_id', 'org_id', 'slug', 'display_name', 'status', 'created_at', 'created_by']) {
    if (typeof record[field] !== 'string') {
      throw new ApiClientError('malformed', 200, 'malformed_response', `project.${field} must be a string`);
    }
  }
  if (record.archived_at !== null && typeof record.archived_at !== 'string') {
    throw new ApiClientError('malformed', 200, 'malformed_response', 'project.archived_at is malformed');
  }
  return record as unknown as Project;
}

export async function listProjects(): Promise<Project[]> {
  const payload = await requestJson('/v1/projects');
  return responseArray(payload, 'projects').map(projectFrom);
}

export async function createProject(input: { slug: string; displayName: string }): Promise<Project> {
  const payload = await requestJson('/v1/projects', {
    method: 'POST',
    body: JSON.stringify({ slug: input.slug, display_name: input.displayName }),
  });
  return projectFrom(responseRecord(payload, 'project'));
}

export async function getProject(projectId: string): Promise<Project> {
  const payload = await requestJson(`/v1/projects/${encodeURIComponent(projectId)}`);
  return projectFrom(responseRecord(payload, 'project'));
}
